import {
  REPORT_RE_SEND, REPORT_RE_SEND_SUCCESS, REPORT_RE_SEND_FAILURE,
  REPORT_SEND_CANCEL, REPORT_SEND_CANCEL_SUCCESS, REPORT_SEND_CANCEL_FAILURE,
  REPORT_SEND_RESTART, REPORT_SEND_RESTART_SUCCESS, REPORT_SEND_RESTART_FAILURE
} from './mutation-types'
import constant from '../constant'
var utils = require('../../utils')

export default {
  utils: utils,
  state: {
    reportSendNotify: null
  },
  getters: {
    reportSendNotify: state => {
      return state.reportSendNotify
    }
  },
  actions: {
    /** 再送信 */
    [REPORT_RE_SEND] ({dispatch, state, commit}, params) {
      var data = params.data
      var url = '/report_sends/resend'
      var loadparams = 'block'
      var callback = params.callback
      if (params) {
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiPost', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_RE_SEND_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_RE_SEND_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** 送信停止 */
    [REPORT_SEND_CANCEL] ({dispatch, state, commit}, params) {
      var data = params.data
      var url = '/report_sends/cancel_send'
      var loadparams = 'block'
      var callback = params.callback
      if (params) {
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiPost', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_SEND_CANCEL_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_SEND_CANCEL_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    /** 送信再開 */
    [REPORT_SEND_RESTART] ({dispatch, state, commit}, params) {
      var data = params.data
      var url = '/report_sends/restart_send'
      var loadparams = 'block'
      var callback = params.callback
      if (params) {
        if ('loadparams' in params) {
          loadparams = params.loadparams
        }
      }
      dispatch('apiPost', {url: url, data: data, loadparams: loadparams})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REPORT_SEND_RESTART_FAILURE, {data: res.data, callback: callback})
          } else {
            commit(REPORT_SEND_RESTART_SUCCESS, {data: res.data, callback: callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    /** 再送信 失敗 */
    [REPORT_RE_SEND_FAILURE] (state, params) {
      console.log('REPORT_RE_SEND_FAILURE')
      var message = params.data.error
      var callback = params.callback
      callback(params)
      // 通知
      state.reportSendNotify = {
        danger: true,
        message: message
      }
      setTimeout(() => { state.reportSendNotify = null }, constant.notifyShowTime.normal)
    },
    /** 再送信 成功 */
    [REPORT_RE_SEND_SUCCESS] (state, params) {
      console.log('REPORT_RE_SEND_SUCCESS')
      var message = 'messages.send.send_report'
      var callback = params.callback

      callback(params)
      // 通知
      state.reportSendNotify = {
        success: true,
        message_i18n: message
      }
      setTimeout(() => { state.reportSendNotify = null }, constant.notifyShowTime.short)
    },

    /** 送信停止 失敗 */
    [REPORT_SEND_CANCEL_FAILURE] (state, params) {
      console.log('REPORT_SEND_CANCEL_FAILURE')
      var message = 'messages.send.danger_report_stop' // 報告書の送信停止に失敗しました
      var callback = params.callback

      callback(params)
      // 通知
      state.reportSendNotify = {
        danger: true,
        message_i18n: message
      }
      setTimeout(() => { state.reportSendNotify = null }, constant.notifyShowTime.normal)
    },
    /** 送信停止 成功 */
    [REPORT_SEND_CANCEL_SUCCESS] (state, params) {
      console.log('REPORT_SEND_CANCEL_SUCCESS')
      var message = 'messages.send.success_report_stop' // 報告書の送信中止に失敗しました
      var callback = params.callback

      callback(params)
      // 通知
      state.reportSendNotify = {
        success: true,
        message: message
      }
      setTimeout(() => { state.reportSendNotify = null }, constant.notifyShowTime.short)
    },

    /** 送信再開 失敗 */
    [REPORT_SEND_RESTART_FAILURE] (state, params) {
      console.log('REPORT_SEND_RESTART_FAILURE')
      var errorData = {
        danger: true,
        message_i18n: 'messages.send.danger_report_restart' // 報告書送信の再開に失敗しました
      }
      var callback = params.callback
      if (params.data.error !== true) {
        errorData = {
          danger: true,
          message: params.data.error
        }
      }

      callback(params)
      // 通知
      state.reportSendNotify = errorData
      setTimeout(() => { state.reportSendNotify = null }, constant.notifyShowTime.normal)
    },
    /** 送信再開 成功 */
    [REPORT_SEND_RESTART_SUCCESS] (state, params) {
      console.log('REPORT_SEND_RESTART_SUCCESS')
      var message = 'messages.send.success_report_restart' // 報告書送信を再開しました。
      var callback = params.callback

      callback(params)
      // 通知
      state.reportSendNotify = {
        success: true,
        message: message
      }
      setTimeout(() => { state.reportSendNotify = null }, constant.notifyShowTime.short)
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/report-send.js